import { useState, useEffect } from "react";

export function useWindowDimension() {
    const [dimension, setDimensions] = useState({
        width: 0,
        height: 0
    });

    useEffect(() => {
        function handleResize() {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }

        handleResize();

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return dimension;
}